import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../redux/globals/globals.actions';
import { selectUser } from '../../redux/globals/globals.selectors';
import Button from '../buttons/button.component';
import './SidebarContent.styles.scss';
import Input from '../../components/formComponents/Input.component';
import mainApi from '../../redux/apis/main-api';

const SidebarContent = () => {
	const user = useSelector(selectUser);
	const [data, setData] = useState({ ...user });
	const [loading, setLoading] = useState(false);
	const [disabled, setDisabled] = useState(true);
	const dispatch = useDispatch();

	const logout = () => {
		mainApi.post('/APIS/user/logout').then(() => {
			dispatch(setUser(null));
			//window.location.reload();
		});
	};

	const saveChanges = () => {
		setLoading(true);
		mainApi.post('/APIS/user/savechanges', { data }).then((res) => {
			dispatch(setUser({ ...user, ...data }));
			setLoading(false);
			setDisabled(true);
		});
	};

	const handleChange = (e) => {
		let value = e.target.type === 'checkbox' ? (e.target.checked ? 1 : 0) : e.target.value;
		let name = e.target.name;

		setDisabled(false);

		let newData = { ...data };
		let splitProperty = e.target.name.split('.');

		if (e.target.name.indexOf('.') !== -1) {
			newData = { ...newData, [splitProperty[0]]: { ...newData[splitProperty[0]], [splitProperty[1]]: value } };
			setData(newData);
		} else {
			setData({ ...newData, [name]: value });
		}
	};

	return (
		<div className="sidebar-content">
			{user && (
				<>
					<div className="profile-top">
						<div className="user-data">
							<h3 className="name">{`Hi, ${user.name || 'Guest'}`}</h3>

							<Button className="logout" onClick={logout}>
								Logout
							</Button>
						</div>
					</div>

					<div className="profile">
						<h3 className="title">Edit your profile</h3>
						<div className="desc">All profile data is optional. Email is used for announcments.</div>

						<div className="form-item">
							<label>Full name or nickname</label>
							<Input name="name" value={data.name} onChange={handleChange} />
						</div>
						<div className="form-item">
							<label>Email</label>
							<Input name="email" value={data.email} onChange={handleChange} />
						</div>

						<Button className="save" onClick={saveChanges} isLoading={loading} isDisabled={disabled}>
							Save changes
						</Button>
					</div>
				</>
			)}
		</div>
	);
};

export default SidebarContent;
